import TrainingCategoriesComponent from "../../components/TrainingCategories/TrainingCategories.component";

const TrainingCategoriesPage: React.FC = () => {
    return <TrainingCategoriesComponent />;
};

export default TrainingCategoriesPage;
